import React from 'react';
import {_GPY,__GPYGetRSS} from '../../../env.js'
import GpyToggleButton from './GpyToggleButton.js';
import moment from 'moment';
import 'moment/locale/de';
import * as rssParser from 'react-native-rss-parser';

class ScoreboardFreeTextPanel extends  React.Component {

	constructor(props) {
		super(props);
		this.state = {
		 freeText: _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_freetext_welcome'),
		 crawl_seperator: "point.png",
		 RSSURL:"https://www.guppyi.com/feed",
		 autoReloadRSS: false,
		 abspann:"bold:Credits\nEnter your plain text here\n\nitalic:Italic row example\n\nbig:powered by guppyi.com",
	 };
	}

	setStateAndStore(obj,cb = ()=>{}) {
		this.setState(obj,()=>{
			this.props.scoreboard.markToStore();
				cb();
		});
	}

	componentWillUnmount() {
	}

	componentDidMount() {
		try {
			this.props.scoreboard.registerHooks(this.props.scoreboard.getName()+"_ScoreboardFreeTextPanel",this);
		} catch (e) {
			console.log(e);
		}
	}

	loadGameData(o) {
		this.loadUserData(o);
	}
	loadUserData(o) {
		let d = {};
		if(o.freeTextRssUrl !== undefined) {
			d.RSSURL =  o.freeTextRssUrl
		}
		if(o.freeTextContent !== undefined) {
			d.freeText =  o.freeTextContent
		}
		if(o.creditsContent !== undefined) {
			d.abspann =  o.creditsContent
		}
		this.setState(d);
	}

  storeGameData(c){
		this.storeUserData(c);
	}

	storeUserData(o) {
		o.freeTextRssUrl = this.state.RSSURL;
		o.freeTextContent = this.state.freeText;
		o.creditsContent = this.state.abspann;
	}

	genFromRSS(){
			__GPYGetRSS(this.state.RSSURL,(res)=>{
				var content = "";
				var items = res.items
				items.map((i)=>{
					var d = "";
					try {
						var id =  new Date(_GPY.removeTags(i.published.trim()));
						d = id.toLocaleString();// ("0"+id.getDay()).slice(-2)+"."+("0"+id.getMonth()).slice(-2)+" "+("0"+id.getHours()).slice(-2) + ":" +("0"+id.getMinutes()).slice(-2) + " Uhr : ";
					} catch (e) {
						console.log(e);
					}
					content += d + " " +i.title +" - "+ _GPY.removeTags(i.description.trim())+"\n";
				});
				content = _GPY.decodeHtml(content);
				this.setState({freeText:content},()=>{
					var crawlBtn = this.props.scoreboard.state.components[this.props.scoreboard.getName()+"_button_freetext_crawl"];
					if(crawlBtn!==undefined) {
						crawlBtn.updateData();
					}
					this.props.scoreboard.setState({toStore:true});
				});
			});
		}

  render () {
		const sponsorLogo = this.props.scoreboard.state.currentGame.sponsorLogo!==undefined&&this.props.scoreboard.state.currentGame.sponsorLogo!==''?this.props.scoreboard.state.currentGame.sponsorLogo:"empty.png";

    return (
			<>
			<div className="row">
					<div className="col-12 p-1">
						 <div className="form-group">
							<label htmlFor="exampleFormControlTextarea1"><strong>{_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_freetext_title')}</strong></label>
								<textarea className="form-control" ignorekeys="true"
								  onChange={(e)=>this.setStateAndStore({freeText:e.target.value})}
									value={this.state.freeText} id="exampleFormControlTextarea1" rows={this.props.textRows!==undefined?this.props.textRows:3}></textarea>
						 </div>
					</div>

			</div>


				<div className="row">
					{this.props.showFreeText===undefined||this.state.showFreeText===true?
					<div className="col-4 p-1">
							<GpyToggleButton
									title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_freetext_button_text')}
									onInit={() => {return {}}}
									onDeactivate={() => {return {visible: false,text:""}}}
									onActivate={() => {return {visible: true,text: this.state.freeText}}}
									scoreboard={this.props.scoreboard}
									getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
									stateName={this.props.scoreboard.getName()+"_button_freetext"}/>
					</div>
					:""}
					<div className={this.props.showFreeText===undefined||this.state.showFreeText===true?"col-8 p-1":"col-12 p-1"}>
								<div class="btn-group btn-group-sm btn-block" role="group" aria-label="Basic example">

								<div class="btn-group  btn-group-sm" role="group">
  								<button id="btnGroupDrop1" type="button" className="btn btn-sm btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							      <img style={{maxWidth:"1rem"}} src={_GPY.resource("upload/"+this.state.crawl_seperator)} className="img-fluid" alt=""/>
							    </button>

							    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
									{this.props.scoreboard.state.currentGame!==undefined&&this.props.scoreboard.state.currentGame.teamMap!==undefined&&this.props.scoreboard.state.currentGame.teamMap.HOME_TEAM!==undefined?
							 				<a class="dropdown-item" href="#" onClick={()=>this.setState({crawl_seperator:this.props.scoreboard.state.currentGame.teamMap.HOME_TEAM.logo})}><img style={{maxWidth:"1rem"}} src={_GPY.resource("upload/"+this.props.scoreboard.state.currentGame.teamMap.HOME_TEAM.logo)} className="img-fluid" alt=""/></a>
									:""}
									{this.props.scoreboard.state.currentGame!==undefined&&this.props.scoreboard.state.currentGame.teamMap!==undefined&&this.props.scoreboard.state.currentGame.teamMap.GUEST_TEAM!==undefined?
										 <a class="dropdown-item" href="#" onClick={()=>this.setState({crawl_seperator:this.props.scoreboard.state.currentGame.teamMap.GUEST_TEAM.logo})}><img style={{maxWidth:"1rem"}} src={_GPY.resource("upload/"+this.props.scoreboard.state.currentGame.teamMap.GUEST_TEAM.logo)} className="img-fluid" alt=""/></a>
									:""}
							      {sponsorLogo!==undefined&&sponsorLogo!==""?<a class="dropdown-item" href="#" onClick={()=>this.setState({crawl_seperator:sponsorLogo})}><img style={{maxWidth:"1rem"}} src={_GPY.resource("upload/"+sponsorLogo)} className="img-fluid" alt=""/></a>:<></>}
										<a class="dropdown-item" href="#" onClick={()=>this.setState({crawl_seperator:"point.png"})}><img style={{maxWidth:"1rem"}} src={_GPY.resource("upload/point.png")} className="img-fluid" alt=""/></a>
										<a class="dropdown-item" href="#" onClick={()=>this.setState({crawl_seperator:"star.png"})}><img style={{maxWidth:"1rem"}} src={_GPY.resource("upload/star.png")} className="img-fluid" alt=""/></a>
										<a class="dropdown-item" href="#" onClick={()=>this.setState({crawl_seperator:"empty.png"})}>empty</a>
							    </div>
								</div>

								<GpyToggleButton
											title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_freetext_crawl_button_text')}
											onInit={() => {return {}}}
											onDeactivate={() => {return {visible: false,text:""}}}
											onActivate={() => {return {visible: true,
												text: this.state.freeText,
												separatorImage:this.state.crawl_seperator!==undefined?this.state.crawl_seperator:this.props.screboard.state.currentGame.teamMap.HOME_TEAM.logo,
												crawlRightToLeft:this.props.scoreboard.state.crawlRightToLeft,
											}}}
											scoreboard={this.props.scoreboard}
											getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
											stateName={this.props.scoreboard.getName()+"_button_freetext_crawl"}/>
											<button type="button" class="btn btn-sm btn-secondary" onClick={(e)=>{
												this.props.scoreboard.setState({crawlRightToLeft:!this.props.scoreboard.state.crawlRightToLeft});
											}}>
												<span className={this.props.scoreboard.state.crawlRightToLeft?"glyphicon glyphicon-arrow-left":"glyphicon glyphicon-arrow-right"} aria-hidden="true"></span>
											</button>
									 </div>
					</div>
			</div>

			{this.props.rss===undefined || this.props.rss === true?




					 <div className="row">
							 <div className="col-12 p-1"><strong>Generieren</strong></div>

					 <div  className="col-12 p-1">
								<div className="form-group">
								<input type="Text" onChange={(e)=>{
									this.setState({RSSURL:e.target.value});
									this.props.scoreboard.setState({toStore:true});
								}} className="form-control" aria-describedby="_RSSURL" value={this.state.RSSURL} placeholder="rss URL"/>
								</div>
								</div>
								<div className="col-12 p-1">
							<div className="btn-group w-100" role="group" aria-label="Basic example">
								<button type="button"  className="btn btn-secondary btn-sm" onClick={()=>{
									 this.genFromRSS();
								}}>{_GPY.i18n.get('gametype_any_scoreboard_freetext_gen_from_rss')}</button>
								<button type="button"  className={"btn btn-sm " + (this.state.autoReloadRSS?"btn-danger":"btn-dark")} onClick={()=>{
									 if(this.state.autoReloadRSS) {
										 clearInterval(this.autoUpdateInterval);
										 this.setState({autoReloadRSS:false});
									 } else {
										 this.autoUpdateInterval = setInterval(()=>{
												this.genFromRSS();
										 },this.props.autoReloadRSSTime!==undefined?this.props.autoReloadRSSTime:(30*60*1000));
										 this.setState({autoReloadRSS:true});
									 }
								}}><div style={{ animation: (!this.state.autoReloadRSS?" emptyanim":" rotateAnim 10s infinite linear")}}><span className="glyphicon glyphicon-refresh" aria-hidden="true"></span></div></button>
								</div>
							</div>
					 </div>
			:""}



	{this.props.scoreboard.state.currentGame!==undefined&&this.props.scoreboard.state.currentGame.id>0?
		<>	<div className="row">
	 			<div className="col-6 p-1">
				 <button className="btn btn-secondary btn-sm btn-block" onClick={()=>{
					 const g = this.props.scoreboard.state.currentGame;
					 console.log(g);
					 var val = "";
					 var playerList = [];
					 g.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_PLAYER')).forEach((p)=>{
						 var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						 playerList.push(name);
					 });

					 var gplayerList = [];
					 g.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_PLAYER')).forEach((p)=>{
						 var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						 gplayerList.push(name);
					 });

					 var playerListSub = [];
					 g.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_SUBSTITUE')).forEach((p)=>{
						 var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						 playerListSub.push(name);
					 });
					 var gplayerListSub = [];
					 g.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_SUBSTITUE')).forEach((p)=>{
						 var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						 gplayerListSub.push(name);
					 });
					 var coachList = [];
					 g.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_COACH')).forEach((p)=>{
						var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						coachList.push(name);
					 });

					 var gcoachList = [];
					 g.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_COACH')).forEach((p)=>{
						var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						gcoachList.push(name);
					 });

					 if(playerList.length>0) val = g.teamMap.HOME_TEAM.name + " Player : " + playerList.join(", ");
					 if(playerListSub.length>0) val =  val + "\n" + g.teamMap.HOME_TEAM.name + " Substitue : " + playerListSub.join(", ");
					 if(coachList.length>0) val =  val + "\n" + g.teamMap.HOME_TEAM.name + " Coach : " + coachList.join(", ");

					 if(gplayerList.length>0) val = val + "\n" + g.teamMap.GUEST_TEAM.name + " Player : " + gplayerList.join(", ");
					 if(gplayerListSub.length>0) val =  val + "\n" + g.teamMap.GUEST_TEAM.name +" Substitue : " + gplayerListSub.join(", ");
					 if(gcoachList.length>0) val =  val + "\n" + g.teamMap.GUEST_TEAM.name + " Coach : " + gcoachList.join(", ");

					 this.setState({freeText:val.trim()});
				 }}>{_GPY.i18n.get('gametype_any_scoreboard_freetext_gen_lineup')}</button>
			 </div>


			 <div className="col-6 p-1">
			 <button className="btn btn-secondary btn-sm  btn-block" onClick={()=>{
				 var val = "";
				 if(this.props.scoreboard.state.gamesIsLoaded) {
					 this.props.scoreboard.state.games.Games.Game.forEach((t) => {
						 if( (_GPY.toLocaleMoment(t.endTime) + (1000*60*60)) > _GPY.toLocaleMoment(moment()) )  {
							 val = t.gameName + " (" + moment(t.startTime).locale('de').format('L') + " " + moment(t.startTime).locale(_GPY.locale).format('HH:mm')+" - "+ moment(t.endTime).locale(_GPY.locale).format('HH:mm')+")";
						 }
				 });
			 }
			 this.setState({freeText:val.trim()});
		 }}>{_GPY.i18n.get('gametype_any_scoreboard_freetext_gen_next_games')}</button>

			 </div>
		 </div>

<div className="row"><div className="col-12 p-1"><hr/></div></div>

     {this.props.credits!==undefined&&this.props.credits?
		 <div className="row">
			<div className="col-12  p-1">
				<div className="form-group">
					<label><strong>{_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_credits')}</strong></label>
				  	<textarea className="form-control" ignorekeys="true" onChange={(e)=>{this.setStateAndStore({abspann:e.target.value})}} value={this.state.abspann} rows={6}></textarea>
					</div>
			</div>
			<div className="col-12  p-1">

			 <GpyToggleButton
					title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_button_credits_title',"start/restart credits")}
					onInit={() => {return {}}}
					onDeactivate={() => {return {visible: false,text:""}}}
					onActivate={() => {return {visible: true,
						text : this.state.abspann,
					}}}
					scoreboard={this.props.scoreboard}
					getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
					stateName={this.props.scoreboard.getName() + "_button_credits"}
			 />

			</div>
			</div>
			:""}

			</>
  	 :""}

		 <div className="row"><div className="col-12 p-1"><hr/></div></div>
		 </>
		);
  }
}
export default ScoreboardFreeTextPanel;
